import BasicRouterView from "../../components/BasicRouterView.vue";

const requisicaoRoutes = {
  path: "req",
  redirect: { name: "requisicao-lista" },
  meta: {
    label: "Requisição",
    icon: "add_task",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "requisicao/nova-requisicao-material",
      name: "nova-requisicao-material",
      meta: {
        label: "Nova Requisição Material",
        icon: "pending_actions",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoMaterial.vue"
        ),
    },
    {
      path: "requisicao/nova-requisicao-material-epis",
      name: "nova-requisicao-material-epis",
      meta: {
        label: "Nova Requisição Material EPIs",
        icon: "pending_actions",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoMaterialCategoriaA.vue"
        ),
    },
    {
      path: "requisicao/nova-requisicao-material-uniformes",
      name: "nova-requisicao-material-uniformes",
      meta: {
        label: "Nova Requisição Material Uniformes",
        icon: "pending_actions",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoMaterialCategoriaB.vue"
        ),
    },
    {
      path: "requisicao/nova-requisicao-material-nr10",
      name: "nova-requisicao-material-nr10",
      meta: {
        label: "Nova Requisição Material NR10",
        icon: "pending_actions",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoMaterialCategoriaC.vue"
        ),
    },
    {
      path: "requisicao/nova-requisicao-material-todos",
      name: "nova-requisicao-material-todos",
      meta: {
        label: "Nova Requisição Todos Materiais",
        icon: "pending_actions",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoMaterialTodos.vue"
        ),
    },

    {
      path: "requisicao/nova-requisicao-material-todos-epis",
      name: "nova-requisicao-material-todos-epis",
      meta: {
        label: "Nova Requisição Todos Materiais Categoria A",
        icon: "pending_actions",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoMaterialTodosCategoriaA.vue"
        ),
    },
    {
      path: "requisicao/nova-requisicao-balcao",
      name: "nova-requisicao-balcao",
      meta: {
        label: "Nova Requisição Balcão",
        icon: "fact_check",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoBalcao.vue"
        ),
    },
    {
      path: "requisicao/nova-requisicao-balcao-epis",
      name: "nova-requisicao-balcao-epis",
      meta: {
        label: "Nova Requisição Balcão EPIs",
        icon: "fact_check",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoBalcaoCategoriaA.vue"
        ),
    },
    {
      path: "requisicao/nova-requisicao-balcao-uniformes",
      name: "nova-requisicao-balcao-uniformes",
      meta: {
        label: "Nova Requisição Balcão Uniformes",
        icon: "fact_check",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoBalcaoCategoriaB.vue"
        ),
    },
    {
      path: "requisicao/nova-requisicao-balcao-uniformes-nr10",
      name: "nova-requisicao-balcao-uniformes-nr10",
      meta: {
        label: "Nova Requisição Balcão Uniformes NR10",
        icon: "fact_check",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoBalcaoCategoriaC.vue"
        ),
    },
    {
      path: "requisicao/lista",
      name: "requisicao-lista",
      meta: {
        label: "Listagem de Requisições",
        icon: "assignment",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "requisicao" */ "./views/Listar.vue"),
    },
    {
      path: "requisicao/lista-logado",
      name: "requisicao-lista-logado",
      meta: {
        label: "Listagem de Requisições User",
        icon: "assignment",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/ListarUserLogado.vue"
        ),
    },
    {
      path: "requisicao/fluxo-completo",
      name: "nova-requisicao-fluxo-completo",
      meta: {
        label: "Fluxo Completo",
        icon: "account_tree",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/FluxoCompleto.vue"
        ),
    },
    {
      path: "requisicao/fluxo-completo-epis",
      name: "nova-requisicao-fluxo-completo-epis",
      meta: {
        label: "Fluxo Completo EPIs",
        icon: "account_tree",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/FluxoCompletoCategoriaA.vue"
        ),
    },
    {
      path: "requisicao/fluxo-completo-uniformes",
      name: "nova-requisicao-fluxo-completo-uniformes",
      meta: {
        label: "Fluxo Completo Uniformes",
        icon: "account_tree",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/FluxoCompletoCategoriaB.vue"
        ),
    },
    {
      path: "requisicao/fluxo-completo-uniformes-nr10",
      name: "nova-requisicao-fluxo-completo-uniformes-nr10",
      meta: {
        label: "Fluxo Completo Uniformes NR10",
        icon: "account_tree",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/FluxoCompletoCategoriaC.vue"
        ),
    },
    {
      path: "requisicao/nova-requisicao-grupo",
      name: "nova-requisicao-grupo",
      meta: {
        label: "Nova Requisição Grupo",
        icon: "add_business",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/NovaRequisicaoGrupo.vue"
        ),
    },
    {
      path: "requisicao/detalhe/:requisicaoId?",
      name: "requisicao-detalhe",
      meta: {
        label: "Requisição Detalhe",
        icon: "business",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/RequisicaoDetalhe.vue"
        ),
    },
    {
      path: "requisicao/arquivos/:requisicaoId?",
      name: "requisicao-arquivos",
      meta: {
        label: "Requisição Arquivos",
        icon: "business",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/RequisicaoArquivos.vue"
        ),
    },
    {
      path: "requisicao/imprimir-requisicao/:requisicaoId?",
      name: "requisicao-imprimir",
      meta: {
        label: "",
        icon: "",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "requisicao" */ "./views/ImpressaoRequisicao.vue"
        ),
    },
  ],
};

export default requisicaoRoutes;
